import { c as _c } from "react/compiler-runtime";
import { NEXTGEN_CHAIN_ID, NEXTGEN_CORE } from "@/components/nextGen/nextgen_contracts";
import { publicEnv } from "@/config/env";
import { GRADIENT_CONTRACT, MEMES_CONTRACT } from "@/constants/constants";
import type { DBResponse } from "@/entities/IDBResponse";
import type { Transaction } from "@/entities/ITransaction";
import { fetchUrl } from "@/services/6529api";
import { useEffect, useState } from "react";
export enum TypeFilter {
  ALL = "All Transactions",
  AIRDROPS = "Airdrops",
  MINTS = "Mints",
  SALES = "Sales",
  TRANSFERS = "Transfers",
  BURNS = "Burns",
}
enum ContractFilter {
  ALL = "All Collections",
  MEMES = "The Memes",
  NEXTGEN = "NextGen",
  GRADIENTS = "Gradients",
}
interface UseActivityDataReturn {
  // Data
  activity: Transaction[];
  totalResults: number;

  // Loading state
  fetching: boolean;

  // Pagination
  page: number;
  setPage: (page: number) => void;
}
export function useActivityData(initialPage, pageSize, typeFilter, selectedContract, initialData) {
  const $ = _c(15);
  let t0;
  if ($[0] !== initialData?.activity) {
    t0 = initialData?.activity || [];
    $[0] = initialData?.activity;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [activity, setActivity] = useState(t0);
  const [page, setPage] = useState(initialPage);
  const [totalResults, setTotalResults] = useState(initialData?.totalResults || 0);
  const [fetching, setFetching] = useState(false);
  let t1;
  let t2;
  if ($[2] !== initialData || $[3] !== initialPage || $[4] !== page || $[5] !== pageSize || $[6] !== selectedContract || $[7] !== typeFilter) {
    t1 = () => {
      const hasInitialData = initialData && initialData.activity.length > 0;
      const isDefaultFilters = typeFilter === TypeFilter.ALL && selectedContract === ContractFilter.ALL;
      const isInitialPage = page === initialPage;
      if (hasInitialData && isDefaultFilters && isInitialPage) {
        return;
      }
      setFetching(true);
      let url = `${publicEnv.API_ENDPOINT}/api/transactions?page_size=${pageSize}&page=${page}`;
      bb37: switch (typeFilter) {
        case TypeFilter.SALES:
          {
            url = url + "&filter=sales";
            break bb37;
          }
        case TypeFilter.TRANSFERS:
          {
            url = url + "&filter=transfers";
            break bb37;
          }
        case TypeFilter.AIRDROPS:
          {
            url = url + "&filter=airdrops";
            break bb37;
          }
        case TypeFilter.MINTS:
          {
            url = url + "&filter=mints";
            break bb37;
          }
        case TypeFilter.BURNS:
          {
            url = url + "&filter=burns";
          }
      }
      bb48: switch (selectedContract) {
        case ContractFilter.MEMES:
          {
            url = url + `&contract=${MEMES_CONTRACT}`;
            break bb48;
          }
        case ContractFilter.NEXTGEN:
          {
            url = url + `&contract=${NEXTGEN_CORE[NEXTGEN_CHAIN_ID]}`;
            break bb48;
          }
        case ContractFilter.GRADIENTS:
          {
            url = url + `&contract=${GRADIENT_CONTRACT}`;
          }
      }
      fetchUrl(url).then(response => {
        setTotalResults(response.count);
        setActivity(response.data);
      }).catch(error => {
        console.error("Failed to fetch activity data", error);
        setTotalResults(0);
        setActivity([]);
      }).finally(() => {
        setFetching(false);
      });
    };
    t2 = [page, typeFilter, selectedContract, pageSize, initialData, initialPage];
    $[2] = initialData;
    $[3] = initialPage;
    $[4] = page;
    $[5] = pageSize;
    $[6] = selectedContract;
    $[7] = typeFilter;
    $[8] = t1;
    $[9] = t2;
  } else {
    t1 = $[8];
    t2 = $[9];
  }
  useEffect(t1, t2);
  let t3;
  if ($[10] !== activity || $[11] !== fetching || $[12] !== page || $[13] !== totalResults) {
    t3 = {
      activity,
      totalResults,
      fetching,
      page,
      setPage
    };
    $[10] = activity;
    $[11] = fetching;
    $[12] = page;
    $[13] = totalResults;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}
export { ContractFilter };